var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[(_vm.inProd)?_c('iframe',{ref:"catchAll",staticStyle:{"height":"100vh","width":"100%"},attrs:{"src":_vm.iframeUrl},on:{"load":_vm.onLoadHandler}}):_c('div',{staticStyle:{"padding-left":"50px"}},[_vm._v("In production, I would have tried to show "+_vm._s(_vm.iframeUrl)+" here.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }